import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

const url = `${AWS_API_URL}/resources`;

export async function getLaundryResources() {
  return getRequest(url, await authorize());
}
